/**
 * @Author:
 * @Description:
 * @DateTime: Created in 22:33 2020/10/9
 */
import _ from 'lodash'
import PublicApi, {PublicApiI} from "../util/publicApi";
import {Result} from "../types/base";
import {CommonUtil} from "../util/commonUtil";

interface EnumCashI {
	list: {id: number,name: string}[]
	nameToId?: {[str: string]: number}
	idToName?: {[num: number]: string}
}
let promiseCash:{[num:number]: Promise<Result<Array<PublicApiI.EnumResI>>>} = {}

let entityCashMap: {[num: number]: EnumCashI} = {}
// 每次
let entityIds:Set<number> = new Set()

export default class EntityFactory {

	constructor (entityId: number[]) {
		this.entityId = entityId
	}

	static clearCache() {
		promiseCash = {}
		entityCashMap = {}
		entityIds = new Set<number>()
	}

	private entityId: number[]


	async initPromise (id: number) {
		if(!promiseCash[id]) {
			// 合并去重
			let idsSet = new Set([...this.entityId,...Array.from(entityIds)])
			// 将已经缓存的删除
			for (let key in promiseCash) {
				if(idsSet.has(+key)) {
					idsSet.delete(+key)
				}
			}
			let ids = Array.from(idsSet)
			let dictPromise = PublicApi.queryEntity({ids: ids.join(',')})
			for (let i = 0, l = ids.length; i < l; i++) {
				let item = ids[i];
				promiseCash[item] = dictPromise
			}
			// 清空
			entityIds = new Set<number>()
		}

		let {ret, rc} = await promiseCash[id]
		if(entityCashMap[id]) {
			return
		}
		if(rc === 0) {
			_.forEach(ret, (item)=>{
				entityCashMap[item.id] = 	{
					list: item.items
				}
			})
		} else {
			delete entityCashMap[id]
			delete promiseCash[id]
		}
	}

	/**
	 * 获取枚举条目
	 * @param {number} dictionaryCategoryId 类别id
	 * @returns {Promise<Array<EnumResI>>}
	 */
	async getEntityList (entityId: number): Promise<Array<{id: number,name: string}>> {
		if(!entityCashMap[entityId]) {
			entityIds.add(entityId)
			await CommonUtil.sleep(0)
			await this.initPromise(entityId)
		}
		return entityCashMap[entityId].list
	}

	/**
	 * 获取枚举名字
	 * @param {number} entityId 枚举所属类别
	 * @param {number} id	枚举id
	 * @returns {Promise<string>}
	 */
	async getNameById (entityId: number,id: number): Promise<string> {
		if(!entityCashMap[entityId]) {
			entityIds.add(entityId)
			await CommonUtil.sleep(0)
			await this.initPromise(entityId)
		}
		this.initNameById(entityId)
		let idToName:any = entityCashMap[entityId].idToName
		return idToName[id]
	}
	initNameById(entityId: number) {
		if(!entityCashMap[entityId].idToName) {
			 let idToName = {}
			_.forEach(entityCashMap[entityId].list,(item)=>{
				idToName[item.id] = item.name
			})
			entityCashMap[entityId].idToName = idToName
		}
	}

	/**
	 * 获取枚举id
	 * @param {number} entityId 枚举所属类别
	 * @param {string} name	枚举name
	 * @returns {Promise<string>}
	 */
	async getIdByName (entityId: number,name: string): Promise<number> {
		if(!entityCashMap[entityId]) {
			entityIds.add(entityId)
			await CommonUtil.sleep(0)
			await this.initPromise(entityId)
		}
		this.initIdByName(entityId)
		let nameToId:any = entityCashMap[entityId].nameToId
		return nameToId[name]
	}

	initIdByName(entityId: number) {
		if(!entityCashMap[entityId].nameToId) {
			let nameToId = {}
			_.forEach(entityCashMap[entityId].list,(item)=>{
				nameToId[item.name] = item.id
			})
			entityCashMap[entityId].nameToId = nameToId
		}
	}
}
